<template>
    <div style="background: #f4f4f4; width: 100%; height: 100%; position: relative">
        <loginHeader />
        <div class="login_root_box">
            <div class="login_center_box">
                <img @click="gotourl1" src="../assets/img2.png" style="position: absolute; width: 92px; height: 90px; right: 0; top: 0" alt="" />
                <div class="login_box_title">账号密码登录</div>
                <input v-model="username" name="" placeholder="手机号码" id="" />
                <div style="position: relative; width: 390px; margin: auto">
                    <input name="" v-model="password" placeholder="密码" :type="mima_show ? 'text' : 'password'" id="" />
                    <img @click="mima_show = !mima_show" v-if="mima_show" src="../assets/wangjimima_kanbujian.png" style="cursor: pointer; width: 16px; height: 8px; position: absolute; right: 0; top: 20px" alt="" />
                    <img @click="mima_show = !mima_show" v-else src="../assets/wangjimima_kandejian.png" style="cursor: pointer; width: 16px; height: 8px; position: absolute; right: 0; top: 20px" alt="" />
                </div>
                <div class="login_but" @click="login" style="cursor: pointer">登录</div>
                <div style="width: 340px; margin: 20px auto; overflow: hidden">
                    <a-checkbox style="float: left">
                        <span class="zidongdenglu">下次自动登录</span>
                    </a-checkbox>
                    <router-link to="/wangjimima"><span class="wangjimima">忘记密码 ?</span></router-link>
                </div>
                <router-link to="/code_login"><div class="duanxindenglu">手机短信登录/注册</div></router-link>
                <div style="width: 60%; margin: 20px auto; overflow: hidden">
                    <a-divider class="qitafangshi_txt">其他方式</a-divider>
                </div>
                <div style="width: 15%; margin: 20px auto; overflow: hidden">
                    <a href=""><img src="../assets/QQicon.png" style="float: left; width: 38px; height: 38px" alt="" /></a>
                    <a href="">
                        <img src="../assets/weixin_icon.png" style="float: right; width: 38px; height: 38px" alt="" />
                    </a>
                </div>
            </div>
        </div>

        <loginFoot />
    </div>
</template>

<script>
import axios from 'axios';
import loginHeader from '../public/login_head';
import loginFoot from '../public/login_foot';
export default {
    name: 'integral',
    components: {
        loginHeader,
        loginFoot
    },
    data() {
        return {
            username: '',
            password: '',
            mima_show: false
        };
    },
    methods: {
        gotourl1() {
            this.$router.push('/login_m');
        },
        login() {
            if (!/^1[3|4|5|8|9][0-9]\d{4,8}$/.test(this.username) || !this.username) {
                this.$message.error('请输入正确的手机号');
                return;
            }
            if (!this.password) {
                this.$message.error('请输入密码');
                return;
            }
            this.api.login({ username: this.username, password: this.password }).then(res => {
                if (res.ok) {
                    // localStorage.Access-Token = res.data.token
                    localStorage.setItem('Access-Token', res.data.token);
                    localStorage.user_info = JSON.stringify(res.data.user);
                    localStorage.username = res.data.user.username;

                    localStorage.uuid = res.data.user.uuid;
                    this.$message.success('登录成功');
                    this.$router.push('/');
                } else {
                    this.$message.error(res.message);
                }
            });
        }
    },
    created() {
        let that = this;
        document.onkeydown = function (e) {
            e = window.event || e;
            if (that.$route.path == '/login' && (e.code == 'Enter' || e.code == 'enter')) {
                //验证在登录界面和按得键是回车键enter
                that.submitForm('login'); //登录函数
            }
        };
    }
};
</script>

<style scoped>
.qitafangshi_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
}
.duanxindenglu {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    text-align: center;
}
.wangjimima {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    float: right;
}
.zidongdenglu {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
.login_but {
    width: 340px;
    height: 48px;
    background: #2b9a34;
    text-align: center;
    line-height: 48px;
    margin: 20px auto;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
}
input {
    width: 340px;
    height: 48px;
    border: 1px solid #ede9e9;
    display: block;
    margin: 30px auto;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    padding-left: 10px;
    outline: none;
}

.login_box_title {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 20px;
    text-align: center;
}

.login_root_box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login_center_box {
    width: 800px;
    height: 520px;
    background: #ffffff;
    position: relative;
}

html,
body,
#app {
    background: #f4f4f4 !important;
}

.bottom_nav_items {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    text-align: center;
    width: 20%;
    float: left;
}

.top_title1 {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    float: left;
    margin-left: 2%;
}

.login_lianxifangshi {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue